import logger from "@/lib/logger";
import { Journal, JournalType, JSONSafe, TaskType } from "@/types";

export type EventSourceMessage =
  | (Pick<Journal, "id" | "type" | "createdAt" | "message"> & {
      type: JournalType;
      taskType?: TaskType;
      appId?: string;
      hostId?: string;
      appName?: string;
      hostName?: string;
    })
  | {
      type: "invalidate";
      createdAt: Date;
      path: string;
    };

export type EventSourceMessageInvalidate = Extract<EventSourceMessage, { type: "invalidate" }>;
export type EventSourceMessageJournal = Extract<EventSourceMessage, { type: JournalType }>;

/** FIXME: https://github.com/rexxars/eventsource-client */
export const createEventSource = (
  onError?: (error: Event) => void,
  onMessage?: (message: JSONSafe<EventSourceMessage>) => void
) => {
  let eventSource = new EventSource("/api/stream");
  let errorThreshold = 10;

  eventSource.addEventListener("open", () => {
    logger.verbose("Event source opened");
  });

  eventSource.addEventListener("message", event => {
    const msg = JSON.parse(event.data as string) as JSONSafe<EventSourceMessage>;
    logger.verbose("Event source message", msg);
    onMessage && onMessage(msg);
  });

  eventSource.addEventListener("error", error => {
    let closed = false;
    const msg = JSON.stringify(error);
    if (
      error.target === eventSource &&
      (eventSource.readyState === EventSource.CLOSED ||
        // FIXME: this is what happens to be sent when the server is shutting down
        msg == '{"isTrusted":true}')
    ) {
      closed = true;
    }
    if (!closed) {
      logger.warn("Event source error", msg);
    }
    eventSource.close();

    // Restart the event source on error
    if (closed || errorThreshold > 0) {
      logger.warn("Reopening event source");
      eventSource = new EventSource("/api/stream");
      if (!closed) {
        errorThreshold = errorThreshold - 1;
      }
    } else {
      onError && onError(error);
    }
  });

  eventSource.addEventListener("ping", event => {
    if (logger.isVerbose) {
      logger.verbose("Event source ping", event);
    }
  });

  return eventSource;
};
